import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { TypeActivityCraComponent } from './components/type-activity-cra/type-activity-cra.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { PagesComponent } from './components/pages/pages.component';
import { SettingsPermissionsComponent } from './components/settings-permissions/settings-permissions.component';
import { ListPermissionsComponent } from './components/list-permissions/list-permissions.component';
import { ChapitreEvalComponent } from './components/chapitre-eval/chapitre-eval.component';
import { MailingComponent } from './components/mailing/mailing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RolesComponent } from './components/roles/roles.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ListReviewsComponent } from './components/list-reviews/list-reviews/list-reviews.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TypeActivityTimesheetComponent } from './components/type-activity-timesheet/type-activity-timesheet/type-activity-timesheet.component';
import { PageintervanantComponent } from './components/pageintervanant/pageintervanant/pageintervanant.component';
import {SharedModule} from 'app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  declarations: [
    TypeActivityCraComponent,
    PaymentMethodComponent,
    PagesComponent,
    SettingsPermissionsComponent,
    ListPermissionsComponent,
    ChapitreEvalComponent,
    MailingComponent,
    RolesComponent,
    ListReviewsComponent,
    TypeActivityTimesheetComponent,
    PageintervanantComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    FieldErrorModule,
    ModalModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    DragDropModule,
    RatingModule.forRoot(),
    SharedModule,
    MatMenuModule
  ],
})
export class SettingsModule {}
